import CopyButton from './CopyButton';
import { ReactNode } from 'react';

type Props = {
  label: string;
  value: ReactNode;
  breakAll?: boolean;
  stacked?: boolean;
  copyable?: boolean;
};

const MISSING_VALUE = '—';

function InfoRow({ label, value, breakAll = false, stacked = false, copyable = false }: Props) {
  const canCopy = copyable && typeof value === 'string' && value !== MISSING_VALUE && value !== '';

  return (
    <div className={`group min-w-0 flex ${stacked ? 'flex-col gap-1' : 'gap-4 items-baseline'}`}>
      <span
        className={`font-klarheit tracking-tight text-sm text-palette-secondary-grey ${
          stacked ? '' : 'w-2/5 shrink-0'
        }`}
      >
        {label}
      </span>
      <span className={`flex min-w-0 items-baseline gap-1 text-base ${breakAll ? 'break-all' : 'break-words'}`}>
        <span className="min-w-0">{value}</span>
        {canCopy && <CopyButton value={value} label={label} />}
      </span>
    </div>
  );
}

export default InfoRow;
